import React, { Component } from 'react';
import { Tabs, Button, message, Select } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
//import SearchRetrieve from '../../common/SearchRetrieve.new.js';
const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

//const yearMonthFormat = 'YYYY-MM';

let markDate = {};
let changeTitle = 'false';

class Filter extends Component {


    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            //const { areaOptions } = this.props;
            //const { label } = (areaOptions || []).find(i => i.value == params['investigationAreaId']) || {};
            //params.investigationAreaName = label;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '统计月份',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        );
    }

    // render() {
        
    //     const { areaOptions, ...rest } = this.props;
    //     const filters = [
    //         {
    //             name: '医院',
    //             key: 'hospital',
    //             type: 'searchRetrieve',
    //             typeProperty: {
    //                 keyword: 'hospitalName',
    //                 style: {width: 160},
    //                 placeholder: '输入名称检索',
    //                 params: {limit: 20},
    //                 url: API_URL.hospital.hospitalList,
    //                 config: { id: 'hospitalId', name: 'hospitalName' }
    //             }
    //         }, {
    //             name: '科室',
    //             key: 'departmentName',
    //             type: 'input',
    //         }, {
    //         name: '项目领域',
    //         key: 'investigationAreaId',
    //         type: 'select',
    //         typeProperty: {
    //             allowClear: true,
    //             list: areaOptions,
    //         }
    //     }];
        
    //     return (
            
    //         <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
    //     )
    // }
}

class QueryOne extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        changeTitle = 'true';
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryCrcStandardAmountList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'ONE',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange22 = () => {
       
        if (changeTitle == 'true') {
            const {searchParams} = this.state;
            markDate = searchParams.date;
            changeTitle = 'false';
        }

        const monthMap = new Map([
            [moment(markDate).add(-11,'M').format(monthFormat), 'firstData'],    
            [moment(markDate).add(-10,'M').format(monthFormat), 'secondData'], 
            [moment(markDate).add(-9,'M').format(monthFormat), 'thirdData'], 
            [moment(markDate).add(-8,'M').format(monthFormat), 'fourthData'], 
            [moment(markDate).add(-7,'M').format(monthFormat), 'fifthData'], 
            [moment(markDate).add(-6,'M').format(monthFormat), 'sixthData'], 
            [moment(markDate).add(-5,'M').format(monthFormat), 'seventhData'], 
            [moment(markDate).add(-4,'M').format(monthFormat), 'eighthData'], 
            [moment(markDate).add(-3,'M').format(monthFormat), 'ninthData'],
            [moment(markDate).add(-2,'M').format(monthFormat), 'tenthData'], 
            [moment(markDate).add(-1,'M').format(monthFormat), 'eleventhData'], 
            [moment(markDate).format(monthFormat), 'twelfthData'],
        ]);
        
        const mymap = [];
        for (let [key, value] of monthMap) {
            mymap.push({
                title: `${key}`,
                dataIndex: `${value}`,
                dataIndex: `${value}`,
                width: 70,
                render: (text, record) => {
                    const isRed = record[`${value}Flag`];
                    return isRed ? <span style={{ color: 'red' }}>{text}</span> : text
                }
            });
        }
        return mymap;
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '人员工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '人员姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 90,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 130,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 120,
        }, {
            title: '各月份标准访视数',
            children:this.handleFilterChange22()
        },{
            title: '最高的四个月平均值',
            dataIndex: 'avgData',
            key: 'avgData',
            width: 120,
            fixed: 'right',
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="queryOne"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class QueryTwo extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        changeTitle = 'true';
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryCrcStandardAmountList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'TWO',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange22 = () => {
       
        if (changeTitle == 'true') {
            const {searchParams} = this.state;
            markDate = searchParams.date;
            changeTitle = 'false';
        }

        const monthMap = new Map([
            [moment(markDate).add(-11,'M').format(monthFormat), 'firstData'],    
            [moment(markDate).add(-10,'M').format(monthFormat), 'secondData'], 
            [moment(markDate).add(-9,'M').format(monthFormat), 'thirdData'], 
            [moment(markDate).add(-8,'M').format(monthFormat), 'fourthData'], 
            [moment(markDate).add(-7,'M').format(monthFormat), 'fifthData'], 
            [moment(markDate).add(-6,'M').format(monthFormat), 'sixthData'], 
            [moment(markDate).add(-5,'M').format(monthFormat), 'seventhData'], 
            [moment(markDate).add(-4,'M').format(monthFormat), 'eighthData'], 
            [moment(markDate).add(-3,'M').format(monthFormat), 'ninthData'],
            [moment(markDate).add(-2,'M').format(monthFormat), 'tenthData'], 
            [moment(markDate).add(-1,'M').format(monthFormat), 'eleventhData'], 
            [moment(markDate).format(monthFormat), 'twelfthData'],
            ]);
        
        const mymap = [];
        for (let [key, value] of monthMap) {
            mymap.push({
                title: `${key}`,
                dataIndex: `${value}`,
                dataIndex: `${value}`,
                width: 70,
            });
        }
        return mymap;
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '人员工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        }, {
            title: '人员姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 90,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 130,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 120,
        }, {
            title: '各月份标准访视数',
            children:this.handleFilterChange22()
        },{
            title: '最高的六个月平均值',
            dataIndex: 'avgData',
            key: 'avgData',
            width: 120,
            fixed: 'right',
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class CrcStandardAmount extends Component {
    state = {
        panes: [{
            title: '临床协调员I',
            key: 'queryOne',
            content: null,
        }, {
            title: '临床协调员II',
            key: 'queryTwo',
            content: null,
        }],
        activeKey: 'queryOne',
        // searchParams: {
        //     date: moment().format(monthFormat),
        // },
        // curParams: {
        //     date: moment().format(monthFormat),
        // },
        searchParams: {},
            curParams: {},
        areaOptions: [],
    }

    componentDidMount() {
        // this.loadAreaList();
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { month, year } = res;
            const { searchParams } = this.state;
            const date = `${year}-${month < 10 ? `0${month}` : month}`;
            searchParams.date = date;
            markDate =  searchParams.date;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                //this.loadData();
                this.updatePanes();
            });
        });
    }

    // loadAreaList = () => {
    //     const options = {
    //         method: 'POST',
    //         url: API_URL.common.queryAllInvestigationArea,
    //         data: {},
    //         dataType: 'json',
    //         doneResult: res => {
    //             const { curParams, searchParams } = this.state;
    //             const areaOptions = (res.data || []).map(item => {
    //                 const { investigationAreaId, investigationAreaName } = item;
    //                 // if (investigationAreaName === '肿瘤') {
    //                 //     curParams.investigationAreaId = investigationAreaId + '';
    //                 //     curParams.investigationAreaName = investigationAreaName;
    //                 //     searchParams.investigationAreaId = investigationAreaId + '';
    //                 //     searchParams.investigationAreaName = investigationAreaName;
    //                 // }
    //                 return {
    //                     label: investigationAreaName,
    //                     value: investigationAreaId,
    //                 };
    //             });
    //             this.setState({
    //                 areaOptions,
    //                 curParams,
    //                 searchParams,
    //             }, () => {
    //                 this.updatePanes();
    //             });
    //         }
    //     };
    //     $.sendRequest(options);
    // }

    search = () => {
        const { searchParams } = this.state;
        this.setState({
            curParams: {...searchParams}
        }, () => {
            const { curParams } = this.state;
            this.childRef.search(curParams);
        });
    }

    export = () => {
        const { activeKey, sortParams, curParams } = this.state;
        const type = (activeKey === 'queryOne' && 'CRC_STANDARD_AMOUNT') || (activeKey === 'queryTwo' && 'CRC_STANDARD_AMOUNT');
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportInvAreaByCRC,
            data: {
                ...sortParams,
                ...curParams,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    updatePanes = () => {
        const { panes, activeKey, curParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'queryOne') {
            RenderContent = QueryOne;
        } else if (activeKey == 'queryTwo') {
            RenderContent = QueryTwo;
        } 
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} searchParams={curParams} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, areaOptions, searchParams } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    areaOptions={areaOptions}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{pane.content}</TabPane>)}
                </Tabs>
            </div>
        );
    }
}

export default CrcStandardAmount;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/crcStandardAmount.js